import { render, staticRenderFns } from "./BInput.vue?vue&type=template&id=a51d5fa2&scoped=true&"
import script from "./BInput.vue?vue&type=script&lang=js&"
export * from "./BInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51d5fa2",
  null
  
)

export default component.exports